<template>
	<div class="fictitious_box" @click.stop="showmenu = false">
		<iframe :src="iframeSrc" class="fictitious_iframe" id="fictitious_iframe" v-if="iframeSrc"></iframe>
		<div class="fictitious_rightBtns" :class="showmenu?'active':''" @click.stop>
			<div class="fictitious_rightBtn fictitious_rightBtn_result" :class="showmenu&&tabmenu=='1'?'active':''" @click.stop="changeTab('1')">
				<img src="@/images/icon_work.png" />
				<div class="fictitious_rightlabel">实验详情</div>
			</div>
			<div class="fictitious_rightBtn fictitious_rightBtn_result" :class="showmenu&&tabmenu=='2'?'active':''" @click.stop="changeTab('2')">
				<img src="@/images/icon_comment.png" />
				<div class="fictitious_rightlabel">实验讨论</div>
			</div>
			<div class="fictitious_rightBtn fictitious_rightBtn_open">
				<img @click="simulationCollection(labInfo)" src="@/images/course_collect2.png" v-if="labInfo.isCollection" />
				<img @click="simulationCollection(labInfo)" src="@/images/course_collect1.png" v-if="!labInfo.isCollection" />
			</div>
		</div>
		<div class="fictitious_right" :class="showmenu?'active':''" @click.stop>
			<div class="fictitious_rightauto darkScorll" v-if="tabmenu=='1'">
				<div class="fictitious_commNav">
					<div class="fictitious_commNavItem active">实验目的</div>
				</div>
				<div class="fictitious_info" v-html="labInfo.introductionHtml">
				</div>
				<div class="fictitious_commNav">
					<div class="fictitious_commNavItem active">实验介绍</div>
				</div>
				<div class="fictitious_info" v-html="labInfo.scoreEvaluate">
				</div>
			</div>
			<lab-commont-list v-if="tabmenu=='2'" :vrDetailId="vrDetailId">
			</lab-commont-list>
		</div>
	</div>
</template>

<script>
	import { getStorageToken } from '@/utils/auth.js'
	import { saveResourceScore, removeResourceScore, getResourceScore, getResourceDetail, getResourceDetailClicks, userIsCollection, getResourceDetailRecord, saveResourceDetailRecord, userCollectionSave, userCollectionRemove } from '@/api/simulation.js'
	import labCommontList from '@/views/fictitious/components/labCommontList.vue'
	export default {
		name: 'fictitiousdetail',
		components: {
			labCommontList,
		},
		data() {
			return {
				vrDetailId: this.$route.query.vrDetailId,
				type: this.$route.query.type,
				resourceId: this.$route.query.resourceId,
				pid: this.$route.query.pid || "",
				labInfo: {},
				iframeSrc: "",
				showmenu: false,
				tabmenu: '1',
			}
		},
		created() {
			this.getResourceDetail();
		},
		methods: {
			changeTab(tabmenu) {
				if(this.tabmenu == tabmenu) {
					this.tabmenu = '0';
					this.showmenu = false
				} else {
					this.tabmenu = tabmenu;
					this.showmenu = true
				}
			},
			getResourceDetail() {
				getResourceDetail({
					vrDetailId: this.vrDetailId,
					resourceId: this.resourceId,
				}).then(res => {
					this.labInfo = res.data || {};
					this.userIsCollection();
					if(res.data.version == 'HTML') {
						this.iframeSrc = res.data.url;
					} else {
						this.iframeSrc = './webgl/' + this.type + '.html?vrDetailId=' + this.vrDetailId + '&resourceId=' + this.resourceId + '&pid=' + this.pid;
					}
					this.$nextTick(() => {
						this.screenFull();
					})
				})
			},
			userIsCollection() {
				userIsCollection({
					id: this.resourceId,
				}).then(res => {
					this.labInfo = Object.assign({}, this.labInfo, {
						isCollection: res.data ? true : false
					})
				})
			},
			simulationCollection(item) {
				var token = getStorageToken();
				if(token) {
					if(!item.isCollection) {
						userCollectionSave({
							vrDetailId: item.id,
							resourceId: item.resourceId,
						}).then(res => {
							if(res.code == "OK") {
								this.$message({
									type: 'success',
									message: "收藏成功!",
								})
								this.labInfo.isCollection = true
							} else {
								this.$message({
									type: 'error',
									message: res.data.message,
								})
							}
						})
					} else {
						userCollectionRemove({
							vrDetailId: item.id,
							resourceId: item.resourceId,
						}).then(res => {
							if(res.code == "OK") {
								this.$message({
									type: 'success',
									message: '取消成功!'
								});
								this.labInfo.isCollection = false
							}
						})
					}
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
			screenFull() {
				var height = $('.fictitious_box').height();
				var width = $('.fictitious_box').width();
				var w = height / 9 * 16;
				if(w > width) {
					height = width / 16 * 9;
					w = width;
				}
				document.getElementById('fictitious_iframe').style.height = height + 'px';
				document.getElementById('fictitious_iframe').style.width = w + 'px';
				var iframeWindow = (document.getElementById('fictitious_iframe').contentWindow || document.getElementById('fictitious_iframe').contentDocument);
				iframeWindow.addEventListener('myEvent', function(event) {
					window.close();
				})
				$('.fictitious_box').unbind('resize');
			},
		},
	}
</script>